import { render, staticRenderFns } from "./GrabIntergration.vue?vue&type=template&id=f97a4176"
import script from "./GrabIntergration.vue?vue&type=script&lang=js"
export * from "./GrabIntergration.vue?vue&type=script&lang=js"
import style0 from "./GrabIntergration.vue?vue&type=style&index=0&id=f97a4176&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports